import React, { useState, useEffect } from 'react';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedCarousel from './components/FeaturedCarousel';
import Products from './components/Products';
import { About, Features } from './components/AboutFeatures';
import Goal from './components/Goal';
import CTA from './components/CTA';
import PremiumCTA from './components/PremiumCTA';
import Footer from './components/Footer';
import Cart from './components/Cart';
import CursorSpotlight from './components/CursorSpotlight';
import { products, features, goals, contactInfo, addToCart, removeFromCart, updateQuantity, getCart, getCartTotal } from './mock';
import './styles/Home.css';
import './styles/EliteEffects.css';

function App() {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Smooth page load
    setIsLoaded(true);
    
    // Add scroll reveal for section headers
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, { threshold: 0.1 });

    const headers = document.querySelectorAll('.section-header');
    headers.forEach(header => observer.observe(header));

    return () => observer.disconnect();
  }, []);

  const handleAddToCart = (product) => {
    const updatedCart = addToCart(product);
    setCart([...updatedCart]);
  };

  const handleRemoveFromCart = (productId) => {
    const updatedCart = removeFromCart(productId);
    setCart([...updatedCart]);
  };

  const handleUpdateQuantity = (productId, quantity) => {
    const updatedCart = updateQuantity(productId, quantity);
    setCart([...updatedCart]);
  };

  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);
  const cartTotal = getCartTotal();

  return (
    <div className={`App ${isLoaded ? 'page-loaded' : ''}`}>
      <div className="grain-overlay" />
      <CursorSpotlight />
      <Toaster position="top-right" theme="dark" />
      <Header 
        cartCount={cartCount}
        onCartClick={() => setIsCartOpen(true)}
      />
      <main>
        <Hero />
        <FeaturedCarousel 
          products={products}
          onAddToCart={handleAddToCart}
        />
        <Products 
          products={products}
          onAddToCart={handleAddToCart}
        />
        <About />
        <Features features={features} />
        <Goal goals={goals} />
        <CTA />
        <PremiumCTA />
        <Footer contactInfo={contactInfo} />
      </main>
      <Cart 
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cart={cart}
        onUpdateQuantity={handleUpdateQuantity}
        onRemoveItem={handleRemoveFromCart}
        cartTotal={cartTotal}
      />
    </div>
  );
}

export default App;
